import { axios } from '@/utils/request'
import qs from 'qs'
let moduleName="mainBody";
export function selectAll(parameter){
  console.log("params:",parameter)
  return axios({
    url: `/ws/${moduleName}`,
    method: 'get',
    params: parameter,
    paramsSerializer: params => {
      return qs.stringify(params, { indices: false })
    }
  })
}

export function listAll(){
  return axios({
    url: `/ws/${moduleName}/listAll`,
    method: 'get',
  })
}

export function selectOne(parameter){
  console.log("id:",parameter)
  return axios({
    url: `/ws/${moduleName}/${parameter}`,
    method: 'get'
  })
}

export function insert(parameter){
  console.log("data:",parameter)
  return axios({
    url: `/ws/${moduleName}`,
    method: 'post',
    data:parameter
  })
}

export function update(parameter){
  console.log("data:",parameter)
  return axios({
    url: `/ws/${moduleName}`,
    method: 'put',
    data:parameter
  })
}


export function deleteObj(ids){
  console.log("ids",ids)
  return axios({
    url: `/ws/${moduleName}`,
    method: 'delete',
    params:ids,
    paramsSerializer: params => {
      return qs.stringify(params, { indices: false })
    }
  })
}
export default {
  selectAll,
  listAll,
  selectOne,
  update,
  save:insert,
  delete:deleteObj,
}